export const articleForWord = (word: string): string =>
  /^[aieouAIEOU]/.test(word) ? ' an ' : ' a ';
